'use strict';

/* eslint-disable indent */

const Swiper = window.Swiper;
var formErrors = require('theme/js/checkout/formErrors');
var liveFormValidation = require('theme/js/components/liveFormValidation');

liveFormValidation($('form'));

$(document).ready(function () {
    $('[data-giftcertificate-form]').submit(function (e) {
        e.preventDefault();
        var form = $(this);

        formErrors.clearPreviousErrors('[data-giftcertificate-form]');
        $.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            data: form.serialize(), // data to be submitted
            success: function (data) {
                $(':input', $('[data-giftcertificate-form]')[0])
                    .not(':button, :submit, :reset, :hidden')
                    .val('');
                $('[giftcertificate-form--error-message]').attr('hidden', true);
                $('body').trigger('giftcertficate:afterAddToCart', data);
            },
            error: function (errorData) {
                var responseJson = errorData.responseJSON;
                var errorMessage;
                switch (errorData.status) {
                case 400:
                    var fieldErrors = responseJson.fieldErrors;
                    if (fieldErrors.length) {
                        fieldErrors.forEach(function (error) {
                            if (Object.keys(error).length) {
                                formErrors.loadFormErrors('[data-giftcertificate-form]', error);
                            }
                        });
                    }
                    break;
                case 500:
                    errorMessage = '';
                    if (responseJson.action == 'CSRF-AjaxFail') {
                        errorMessage = 'Session timed out. Please reload the page and try again.';
                    } else {
                        errorMessage = responseJson.serverErrors.join(', ');
                    }
                    $('[giftcertificate-form--error-message]').html(errorMessage);
                    $('[giftcertificate-form--error-message]').removeAttr('hidden');
                    break;
                default:
                    errorMessage = 'An error has occured, please try again. If the problem persists please contact HSNG support.';
                    $('[giftcertificate-form--error-message]').html(errorMessage);
                    $('[giftcertificate-form--error-message]').removeAttr('hidden');
                }
            }
        });
    });

    // @TODO front end needs to complete this
    // eslint-disable-next-line no-unused-vars
    $('body').on('giftcertficate:afterAddToCart', function (e, data) {
        $('body').trigger('cart:update');
        $('.header').removeClass('scroll-down');
        $('.cart-box-items').empty();
        var $show = $('.added-to-cart-box').show();
        setTimeout(function () {
            $show.hide();
        }, 3000);
        $('.cart-box-items').append('<div class="cart-box-item">'
            + '<div class="cart-box-item-icon"><i class="icon-check"></i></div>'
            + '<div class="cart-box-item-title">'
            + '<span class="cart-box-item-title-name">'
            + data.cart.resources.addGiftCertificateMsg
            + '</span>'
            + '</div>'
            + '</div>');

        $('.minicart-quantity').html(data.cart.numItems);
        $('.minicart-quantity').removeClass('empty-cart');
        $('.minicart .icon-cart').removeClass('empty-cart-trigger');
    });

    var desktopSwiper = new Swiper('.product-carousel.desktop', {
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.product-carousel.desktop .swiper-button-next',
            prevEl: '.product-carousel.desktop .swiper-button-prev',
        },
    });

    $('.product-swatch-images .swatch').click(function () {
        if (!$(this).hasClass('active')) {
            $(this).siblings('.active').removeClass('active');
            $(this).addClass('active');

            desktopSwiper.slideTo($(this).index(), 0);
        }
    });

    desktopSwiper.on('slideChange', function () {
        var productSwatchImages = $('.product-swatch-images .swatch');
        productSwatchImages.siblings('.active').removeClass('active');
        productSwatchImages.eq(desktopSwiper.realIndex).addClass('active');
    });
});
